import { AxiosResponse } from 'axios'
import * as React from 'react'

import { DEFAULT_SIZE } from 'constants/pagination'
import { PaginationParams, PaginationResponse } from 'models/pagination'

type Fetcher<T> = (
  params: PaginationParams,
) => Promise<AxiosResponse<PaginationResponse<T>, any>>

export function usePagination<T>(fetcher: Fetcher<T>) {
  const [list, setList] = React.useState<T[]>([])
  const [count, setCount] = React.useState<number>(0)
  const [page, setPage] = React.useState<number>(0)
  const [fetchingList, setFetchingList] = React.useState<boolean>(false)
  const [params, setParams] = React.useState<Record<string, any>>({})

  const getList = async (selected?: number, requestParams = {}) => {
    setFetchingList(true)
    try {
      const currentPage = selected ?? 1
      setPage(currentPage)
      const { data } = await fetcher({
        offset: (currentPage - 1) * DEFAULT_SIZE,
        ...(Object.keys(requestParams).length > 0 ? requestParams : params),
        limit: DEFAULT_SIZE,
      })

      setList(data.results)
      if (data.count) {
        setCount(Math.ceil(data.count / DEFAULT_SIZE))
      }
    } catch (error) {}
    setFetchingList(false)
  }

  React.useEffect(() => {
    getList(1)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return {
    list,
    count,
    getList,
    fetchingList,
    page,
    setPage,
    setList,
    setParams,
  }
}
